import React from 'react';

import styles from './Switch.module.scss';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  isChecked: boolean;
  onUpdate: (isChecked: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<Props> = ({ isChecked, onUpdate, ...rest }) => {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={isChecked}
      className={`${styles.Outer} ${isChecked ? styles.Checked : ''}`}
      onClick={() => onUpdate(!isChecked)}
      data-testid="switch"
      {...rest}
    >
      <div>
        <i className="mm-check" />
      </div>
    </button>
  );
};

export default Switch;
